import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationCenterActionType, NotificationCenterMessageView } from '@fgb/core';
import * as _moment from 'moment';

@Component({
  selector: 'fgb-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
})
export class NotificationItemComponent implements OnInit {
  @Input() notification: NotificationCenterMessageView;
  actionType = NotificationCenterActionType;
  timer$: Observable<string>;
  id: number = 1;

  constructor() {}

  ngOnInit() {}
}
